import { useEffect, useState } from "react";
import { Image } from "../image/image";
import AdminAPI from "../../api/AdminAPI";
import { DEFAULT_ICON } from "../../config/constants";
import { Text } from "../text/text";

import styles from "./profileInfo.module.css";

export const ProfileInfo = ({ userId = null, name, photo = null }) => {
    const [image, setImage] = useState(null);
    useEffect(() => {
        if (userId) {
            AdminAPI
                .fetchUserPhoto(userId)
                .then(setImage)
                .catch(() => { });
        } else {
            setImage(photo);
        }
    }, [userId, photo]);

    return (
        <div className={styles.button_profile_info}>
            <Image className={styles.button_user_image} width="30px" height="30px" objectFit="cover" src={image || DEFAULT_ICON} />
            <Text as="div" variant="bodyStrong" className={styles.button_user_name}>{name}</Text>
        </div>
    )
}
